import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Autenticacao } from '../autenticacao.service'
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AESEncryptDecryptService } from '../AESEncryptDecryptService'; 
import { CadastroUsuarioService } from '../acesso/cadastro-usuario/cadastro-usuario.service';
import { BeanUsuario } from 'src/bean/BeanUsuario';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  
  imgBannerTecbanHome: string = "../../assets/img/TecbanLogo.png"
  nomeUsuario :string = this._AESEncryptDecryptService.decrypt(localStorage.getItem('nmUser').trim());
  isAdmin : boolean = false;
  nomeUser : string = this.nomeUsuario.indexOf(" ") > 0 ? this.nomeUsuario.substring(0, this.nomeUsuario.indexOf(" ")) : this.nomeUsuario;
  idUser : string = this._AESEncryptDecryptService.decrypt(localStorage.getItem('idUser').trim());
  isMonitor : boolean = this._AESEncryptDecryptService.decrypt(localStorage.getItem('idTipoUsuario').trim()) == '4' ? true : false;
  idRe : string = this._AESEncryptDecryptService.decrypt(localStorage.getItem('reUser').trim());
  isExcluirFicha : boolean = false;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );
  constructor(
      private auth: Autenticacao, 
      private breakpointObserver: BreakpointObserver,
      private router: Router,
      private cadastroUsuarioService : CadastroUsuarioService,
      private _AESEncryptDecryptService: AESEncryptDecryptService
    ) { }


  ngOnInit(): void {
    
    if(this._AESEncryptDecryptService.decrypt(localStorage.getItem('admin')).trim() == 'S'){
      this.isAdmin = true;
    }

    this.router.navigate(['/home/monitoria']);
    this.nomeUsuario = this._AESEncryptDecryptService.decrypt(localStorage.getItem('usuaNmUsuario')).trim();

    this.getUser();   
  }

  public sair(): void {
    this.auth.sair()
  }

  public getUser(){
    this.cadastroUsuarioService.getUsuarioPorId(Number(this.idUser)).then((user:BeanUsuario)=>{
      user.usuaInExcluirFicha == 'S' ? this.isExcluirFicha = true : this.isExcluirFicha = false;
    });
  }

}
